import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { DispatchServices } from './pages/DispatchServices';
import { LeaseOn } from './pages/LeaseOn';
import { ComplianceBackOffice } from './pages/ComplianceBackOffice';
import { ApplyNow } from './pages/ApplyNow';
import { FaqPage } from './pages/FaqPage';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col w-full max-w-full overflow-x-hidden bg-off-white" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/dispatch-services" element={<DispatchServices data-id="element-9" />} data-id="element-8" />
            <Route path="/lease-on-with-fsg" element={<LeaseOn data-id="element-11" />} data-id="element-10" />
            <Route path="/compliance-back-office-support" element={<ComplianceBackOffice data-id="element-13" />} data-id="element-12" />
            <Route path="/apply-now" element={<ApplyNow data-id="element-15" />} data-id="element-14" />
            <Route path="/faq" element={<FaqPage data-id="element-17" />} data-id="element-16" />
            <Route path="/contact" element={<Contact data-id="element-19" />} data-id="element-18" />

            {/* Old URL aliases / redirects */}
            <Route path="/new-page" element={<Navigate to="/lease-on-with-fsg" replace data-id="element-21" />} data-id="element-20" />
            <Route path="/new-page-1" element={<Navigate to="/dispatch-services" replace data-id="element-23" />} data-id="element-22" />
            <Route path="/compliance" element={<Navigate to="/compliance-back-office-support" replace data-id="element-25" />} data-id="element-24" />

            <Route path="*" element={<Navigate to="/" replace data-id="element-27" />} data-id="element-26" />
          </Routes>
        </main>
        <Footer data-id="element-28" />
      </div>
    </BrowserRouter>;
}